module.exports = __webpack_public_path__ + "static/media/logo_bleu.b7fd3954.png";